import {
  SHOW_SUCCESS_ALERT,
  CLOSE_SUCCESS_ALERT,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    isAlertVisible: false,
    message: '',
  },
  mutations: {
    [CLOSE_SUCCESS_ALERT](state) {
      state.isAlertVisible = false;
      state.message = '';
    },
    [SHOW_SUCCESS_ALERT](state, newMessage) {
      state.isAlertVisible = true;
      state.message = newMessage;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/successAlert.js